import React, { FC } from "react";
import { Grid2 as MuiGrid2, Grid2Props } from "@mui/material";

const Grid: FC<Grid2Props> = (props) => <MuiGrid2 {...props} />;

export default Grid;
